// import firebase from 'firebase';

const useAuthentication = () => {
  const getToken = () => {
    return localStorage.getItem("token");
  };

  const setToken = (token) => {
    localStorage.setItem("token", token);
  };

  const getUser = () => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      if(user.role === "64574f6f-fcf8-4d55-a6d8-6bffaf4d308a")
        user = { ...user, authenticated: true, role:"admin"};
      else if(user.role === "d0eff7f7-2740-44ca-850f-836eb28093e6")
        user = { ...user, authenticated: true, role:"donor"};
      else if(user.role === "9e71956c-8cb4-4baa-bc7b-a614d8403c32")
        user = { ...user, authenticated: true, role:"hmo"};
      else if(user.role === "b7d6efab-8745-4e46-87fe-26d80d0f050e")
        user = { ...user, authenticated: true, role:"validator"};
      else if(user.role === "893d8a64-9d23-4ebb-86d6-750b194de98a")
        user = { ...user, authenticated: true, role:"verifier"};
    } else {
      user = { ...user, authenticated: false };
    }
    return user;
  };

  const setUser = (user) => {
    localStorage.setItem("user", JSON.stringify(user)  );
    
  };
  const getRole = (user) => {
    
    
  };

  const unsetAuth = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    // firebase.auth().signOut().then(function() {
    //   console.log('Successfully Signed out')
    // }).catch(function(){
    //   console.log('error Signed out')
    // })
  };

  return { getToken, setToken, setUser, getUser, unsetAuth};
};

export default useAuthentication;